import React, { useRef, useEffect } from 'react';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function lowerCase(str) {
    return str.toLowerCase();
}

var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}

function pascalCaseTransform(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") {
        return "_" + firstChar + lowerChars;
    }
    return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: "", transform: pascalCaseTransform }, options));
}

function dotCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: "." }, options));
}

function paramCase(input, options) {
    if (options === void 0) { options = {}; }
    return dotCase(input, __assign({ delimiter: "-" }, options));
}

const EVENT_PREFIX = 'zui';
function syncEvent(node, eventName, newEventHandler) {
    const eventNameLc = paramCase(eventName[0].toLowerCase() + eventName.substring(1));
    const eventStore = node.__events || (node.__events = {});
    const isDOMEventName = (evName) => !evName.includes('-');
    const getEventName = (evName) => (isDOMEventName(evName) ? evName : `${EVENT_PREFIX}-${evName}`);
    const prefixedEventName = getEventName(eventNameLc);
    const oldEventHandler = eventStore[prefixedEventName];
    if (oldEventHandler) {
        node.removeEventListener(prefixedEventName, oldEventHandler);
    }
    if (newEventHandler) {
        node.addEventListener(prefixedEventName, (eventStore[prefixedEventName] = function handler(e) {
            newEventHandler.call(this, e);
        }));
    }
}
const isListenerName = (name) => name.indexOf('on') === 0 && name[2] === name[2].toUpperCase();
const filterPropsList = ['children', 'style', 'dangerouslySetInnerHTML'];
const reactify = (customElementTagName) => {
    const displayName = pascalCase(customElementTagName);
    const componentFn = React.forwardRef((props, ref) => {
        const elementRef = useRef(undefined);
        useEffect(() => {
            if (!ref) {
                return;
            }
            if (typeof ref === 'function') {
                ref(elementRef.current);
            }
            else {
                ref.current = elementRef.current;
            }
        }, [ref]);
        useEffect(() => {
            if (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) {
                Object.keys(props).forEach((name) => {
                    if (filterPropsList.includes(name)) {
                        return;
                    }
                    const prop = props[name];
                    if (isListenerName(name)) {
                        syncEvent(elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, name.substring(2), prop);
                    }
                    else {
                        elementRef.current[name] = prop;
                    }
                });
            }
        }, [props]);
        let specialProps = {};
        Object.keys(props).forEach((name) => {
            if (filterPropsList.includes(name)) {
                specialProps[name] = props[name];
            }
        });
        return React.createElement(customElementTagName, Object.assign(Object.assign({}, specialProps), { ref: elementRef }));
    });
    componentFn.displayName = displayName;
    return componentFn;
};

const ZuiAboutScreen = reactify('zui-about-screen');

const ZuiActionSplitButton = reactify('zui-action-split-button');

const ZuiActionSplitOption = reactify('zui-action-split-option');

const ZuiAvatar = reactify('zui-avatar');

const ZuiBannerNotification = reactify('zui-banner-notification');

const ZuiBox = reactify('zui-box');

const ZuiButton = reactify('zui-button');

const ZuiChatItem = reactify('zui-chat-item');

const ZuiCheckbox = reactify('zui-checkbox');

const ZuiContentAccordion = reactify('zui-content-accordion');

const ZuiContentAccordionDetails = reactify('zui-content-accordion-details');

const ZuiContentTabBar = reactify('zui-content-tab-bar');

const ZuiContentTabDefaultItem = reactify('zui-content-tab-default-item');

const ZuiContentTabHighlightItem = reactify('zui-content-tab-highlight-item');

const ZuiContentTabImageItem = reactify('zui-content-tab-image-item');

const ZuiDatePicker = reactify('zui-date-picker');

const ZuiDatePickerDayPicker = reactify('zui-date-picker-day-picker');

const ZuiDatePickerInput = reactify('zui-date-picker-input');

const ZuiDatePickerInputPart = reactify('zui-date-picker-input-part');

const ZuiDatePickerInputPartMonth = reactify('zui-date-picker-input-part-month');

const ZuiDatePickerMonthPicker = reactify('zui-date-picker-month-picker');

const ZuiDatePickerYearPicker = reactify('zui-date-picker-year-picker');

const ZuiDialogBox = reactify('zui-dialogbox');

const ZuiDialogButton = reactify('zui-dialog-button');

const ZuiDiv = reactify('zui-div');

const ZuiDivider = reactify('zui-divider');

const ZuiDragDropArea = reactify('zui-drag-drop-area');

const ZuiErrorMessage = reactify('zui-error-message');

const ZuiEwiqDialog = reactify('zui-ewiq-dialog');

const ZuiEwiqDialogButtons = reactify('zui-ewiq-dialog-buttons');

const ZuiEwiqDialogContent = reactify('zui-ewiq-dialog-content');

const ZuiEwiqDialogDescription = reactify('zui-ewiq-dialog-description');

const ZuiEwiqDialogHeadline = reactify('zui-ewiq-dialog-headline');

const ZuiEwiqDialogQuestion = reactify('zui-ewiq-dialog-question');

const ZuiExpander = reactify('zui-expander');

const ZuiFocusViewBar = reactify('zui-focus-view-bar');

const ZuiHeaderbar = reactify('zui-headerbar');

const ZuiHeaderbarIconButton = reactify('zui-headerbar-icon-button');

const ZuiHeaderbarNotificationButton = reactify('zui-headerbar-notification-button');

const ZuiHeaderbarProductName = reactify('zui-headerbar-product-name');

const ZuiHomeScreenTile = reactify('zui-home-screen-tile');

const ZuiIconBar = reactify('zui-icon-bar');

const ZuiInlineMessage = reactify('zui-inline-message');

const ZuiInputPassword = reactify('zui-input-password');

const ZuiInteractionDialog = reactify('zui-interaction-dialog');

const ZuiInteractiveIcon = reactify('zui-interactive-icon');

const ZuiInteractiveText = reactify('zui-interactive-text');

const ZuiList = reactify('zui-list');

const ZuiListAccordion = reactify('zui-list-accordion');

const ZuiListAccordionItem = reactify('zui-list-accordion-item');

const ZuiListItem = reactify('zui-list-item');

const ZuiLoaderBox = reactify('zui-loader-box');

const ZuiMenu = reactify('zui-menu');

const ZuiMenuAnimation = reactify('zui-menu-animation');

const ZuiMenuDivider = reactify('zui-menu-divider');

const ZuiMenuItem = reactify('zui-menu-item');

const ZuiMenuTabBar = reactify('zui-menu-tab-bar');

const ZuiMenuTabIconItem = reactify('zui-menu-tab-icon-item');

const ZuiMenuTabTextItem = reactify('zui-menu-tab-text-item');

const ZuiMenuWrapper = reactify('zui-menu-wrapper');

const ZuiMenubar = reactify('zui-menubar');

const ZuiMenubarDivider = reactify('zui-menubar-divider');

const ZuiMenubarItem = reactify('zui-menubar-item');

const ZuiMenubarNavItem = reactify('zui-menubar-nav-item');

const ZuiMonthPickerInput = reactify('zui-month-picker-input');

const ZuiMultiItemSlider = reactify('zui-multi-item-slider');

const ZuiMultiItemSliderItem = reactify('zui-multi-item-slider-item');

const ZuiMultiItemSliderPagination = reactify('zui-multi-item-slider-pagination');

const ZuiMultilineTextfield = reactify('zui-multiline-textfield');

const ZuiOverlayDirective = reactify('zui-overlay-directive');

const ZuiPageHeader = reactify('zui-page-header');

const ZuiPaginationDot = reactify('zui-pagination-dot');

const ZuiPaginationDotBar = reactify('zui-pagination-dot-bar');

const ZuiPickerGrid = reactify('zui-picker-grid');

const ZuiPickerGridCell = reactify('zui-picker-grid-cell');

const ZuiPickerHeader = reactify('zui-picker-header');

const ZuiPickerHeaderCell = reactify('zui-picker-header-cell');

const ZuiPill = reactify('zui-pill');

const ZuiPillContent = reactify('zui-pill-content');

const ZuiPopover = reactify('zui-popover');

const ZuiPortal = reactify('zui-portal');

const ZuiPortalDirective = reactify('zui-portal-directive');

const ZuiProgressBar = reactify('zui-progress-bar');

const ZuiProgressRing = reactify('zui-progress-ring');

const ZuiQuietLink = reactify('zui-quiet-link');

const ZuiRadioButton = reactify('zui-radio-button');

const ZuiRadioButtonGroup = reactify('zui-radio-button-group');

const ZuiScrollableDirective = reactify('zui-scrollable-directive');

const ZuiScrollbar = reactify('zui-scrollbar');

const ZuiSearchbar = reactify('zui-searchbar');

const ZuiSearchbarInput = reactify('zui-searchbar-input');

const ZuiSearchbarResultsMenu = reactify('zui-searchbar-results-menu');

const ZuiSectionDivider = reactify('zui-section-divider');

const ZuiSelect = reactify('zui-select');

const ZuiSelectAll = reactify('zui-select-all');

const ZuiSelectButton = reactify('zui-select-button');

const ZuiSelectDivider = reactify('zui-select-divider');

const ZuiSelectMenu = reactify('zui-select-menu');

const ZuiSelectOption = reactify('zui-select-option');

const ZuiSelectPlaceholder = reactify('zui-select-placeholder');

const ZuiSlider = reactify('zui-slider');

const ZuiSliderCustom = reactify('zui-slider-custom');

const ZuiSliderRange = reactify('zui-slider-range');

const ZuiSliderScale = reactify('zui-slider-scale');

const ZuiSliderTickLabel = reactify('zui-slider-tick-label');

const ZuiStateDot = reactify('zui-state-dot');

const ZuiStateLabel = reactify('zui-state-label');

const ZuiStepIndicatorBar = reactify('zui-step-indicator-bar');

const ZuiStepIndicatorItem = reactify('zui-step-indicator-item');

const ZuiTable = reactify('zui-table');

const ZuiTag = reactify('zui-tag');

const ZuiTagMenuButton = reactify('zui-tag-menu-button');

const ZuiTextLink = reactify('zui-text-link');

const ZuiTextarea = reactify('zui-textarea');

const ZuiTextfield = reactify('zui-textfield');

const ZuiTextfieldDatePicker = reactify('zui-textfield-date-picker');

const ZuiTextfieldMonthPicker = reactify('zui-textfield-month-picker');

const ZuiTextfieldTimePicker = reactify('zui-textfield-time-picker');

const ZuiThumbnail = reactify('zui-thumbnail');

const ZuiTimePicker = reactify('zui-time-picker');

const ZuiTimePickerCell = reactify('zui-time-picker-cell');

const ZuiTimePickerCellDivider = reactify('zui-time-picker-cell-divider');

const ZuiTimePickerDayTimeToggle = reactify('zui-time-picker-day-time-toggle');

const ZuiTimePickerInput = reactify('zui-time-picker-input');

const ZuiTimePickerInputPartDayTime = reactify('zui-time-picker-input-part-day-time');

const ZuiTimePickerInputPartNumber = reactify('zui-time-picker-input-part-number');

const ZuiTitleStack = reactify('zui-title-stack');

const ZuiTitleStackMetaItem = reactify('zui-title-stack-meta-item');

const ZuiToastNotification = reactify('zui-toast-notification');

const ZuiToggleBar = reactify('zui-toggle-bar');

const ZuiToggleBarButton = reactify('zui-toggle-bar-button');

const ZuiToggleSwitch = reactify('zui-toggle-switch');

const ZuiTooltip = reactify('zui-tooltip');

const ZuiTooltipDirective = reactify('zui-tooltip-directive');

const ZuiTruncateWithTooltip = reactify('zui-truncate-with-tooltip');

const ZuiUserMenuButton = reactify('zui-user-menu-button');

const ZuiZeissLogo = reactify('zui-zeiss-logo');

export { ZuiAboutScreen, ZuiActionSplitButton, ZuiActionSplitOption, ZuiAvatar, ZuiBannerNotification, ZuiBox, ZuiButton, ZuiChatItem, ZuiCheckbox, ZuiContentAccordion, ZuiContentAccordionDetails, ZuiContentTabBar, ZuiContentTabDefaultItem, ZuiContentTabHighlightItem, ZuiContentTabImageItem, ZuiDatePicker, ZuiDatePickerDayPicker, ZuiDatePickerInput, ZuiDatePickerInputPart, ZuiDatePickerInputPartMonth, ZuiDatePickerMonthPicker, ZuiDatePickerYearPicker, ZuiDialogBox, ZuiDialogButton, ZuiDiv, ZuiDivider, ZuiDragDropArea, ZuiErrorMessage, ZuiEwiqDialog, ZuiEwiqDialogButtons, ZuiEwiqDialogContent, ZuiEwiqDialogDescription, ZuiEwiqDialogHeadline, ZuiEwiqDialogQuestion, ZuiExpander, ZuiFocusViewBar, ZuiHeaderbar, ZuiHeaderbarIconButton, ZuiHeaderbarNotificationButton, ZuiHeaderbarProductName, ZuiHomeScreenTile, ZuiIconBar, ZuiInlineMessage, ZuiInputPassword, ZuiInteractionDialog, ZuiInteractiveIcon, ZuiInteractiveText, ZuiList, ZuiListAccordion, ZuiListAccordionItem, ZuiListItem, ZuiLoaderBox, ZuiMenu, ZuiMenuAnimation, ZuiMenuDivider, ZuiMenuItem, ZuiMenuTabBar, ZuiMenuTabIconItem, ZuiMenuTabTextItem, ZuiMenuWrapper, ZuiMenubar, ZuiMenubarDivider, ZuiMenubarItem, ZuiMenubarNavItem, ZuiMonthPickerInput, ZuiMultiItemSlider, ZuiMultiItemSliderItem, ZuiMultiItemSliderPagination, ZuiMultilineTextfield, ZuiOverlayDirective, ZuiPageHeader, ZuiPaginationDot, ZuiPaginationDotBar, ZuiPickerGrid, ZuiPickerGridCell, ZuiPickerHeader, ZuiPickerHeaderCell, ZuiPill, ZuiPillContent, ZuiPopover, ZuiPortal, ZuiPortalDirective, ZuiProgressBar, ZuiProgressRing, ZuiQuietLink, ZuiRadioButton, ZuiRadioButtonGroup, ZuiScrollableDirective, ZuiScrollbar, ZuiSearchbar, ZuiSearchbarInput, ZuiSearchbarResultsMenu, ZuiSectionDivider, ZuiSelect, ZuiSelectAll, ZuiSelectButton, ZuiSelectDivider, ZuiSelectMenu, ZuiSelectOption, ZuiSelectPlaceholder, ZuiSlider, ZuiSliderCustom, ZuiSliderRange, ZuiSliderScale, ZuiSliderTickLabel, ZuiStateDot, ZuiStateLabel, ZuiStepIndicatorBar, ZuiStepIndicatorItem, ZuiTable, ZuiTag, ZuiTagMenuButton, ZuiTextLink, ZuiTextarea, ZuiTextfield, ZuiTextfieldDatePicker, ZuiTextfieldMonthPicker, ZuiTextfieldTimePicker, ZuiThumbnail, ZuiTimePicker, ZuiTimePickerCell, ZuiTimePickerCellDivider, ZuiTimePickerDayTimeToggle, ZuiTimePickerInput, ZuiTimePickerInputPartDayTime, ZuiTimePickerInputPartNumber, ZuiTitleStack, ZuiTitleStackMetaItem, ZuiToastNotification, ZuiToggleBar, ZuiToggleBarButton, ZuiToggleSwitch, ZuiTooltip, ZuiTooltipDirective, ZuiTruncateWithTooltip, ZuiUserMenuButton, ZuiZeissLogo, reactify };
